import { IBase } from "../base.interface";

export enum ConnectorTypes {
  WEB = 'WEB',
  POS = 'POS',
  BORNE = 'BORNE',
  HUBRISE = 'HUBRISE',
  PREVIEW = 'PREVIEW'
}

// PREVIEW est le connecteur unique de prévisualisation : il ne se crée pas depuis le dashboard.
export const CREATABLE_CONNECTOR_TYPES = [ConnectorTypes.WEB, ConnectorTypes.POS, ConnectorTypes.BORNE, ConnectorTypes.HUBRISE];

export const CONNECTOR_TYPE_LABELS: Record<ConnectorTypes, string> = {
  [ConnectorTypes.WEB]: 'Eshop',
  [ConnectorTypes.POS]: 'Caisse',
  [ConnectorTypes.BORNE]: 'Borne',
  [ConnectorTypes.HUBRISE]: 'Hubrise',
  [ConnectorTypes.PREVIEW]: 'Prévisualisation',
};

export interface IConnector extends IBase {
  name: string;

  autoPublish: boolean;

  description: string;

  type: ConnectorTypes;

  hubriseCatalogId?: string;
}
